/**
 * Up to two initials from a display name; from the local part when the value is an email.
 *
 * Case-folding is deliberately restricted to Latin letters. Mkhedruli is a unicameral script, but
 * Unicode still maps it to Mtavruli under toUpperCase() — so an unconditional toUpperCase() turns
 * "ნინო ბერიძე" into "ᲜᲑ", a display form Georgian does not use for initials.
 */
export function initialsOf(name: string): string {
  const source = name.includes('@') ? (name.split('@')[0] ?? '') : name;
  const words = source.split(/[\s._-]+/).filter((w) => w.length > 0);
  return words
    .slice(0, 2)
    .map((w) => {
      const first = [...w][0] ?? '';
      return /[a-z]/.test(first) ? first.toUpperCase() : first;
    })
    .join('');
}
